import T, { forwardRef as y } from "react";
import { cls as N } from "../../helpers/cls.js";
import { withColors as u } from "../../helpers/color.js";
import { spacingReplace as t } from "../../helpers/spacingReplace.js";
import { textDefaultProps as f } from "./props.js";
var H = Object.defineProperty,
  J = Object.defineProperties,
  X = Object.getOwnPropertyDescriptors,
  R = Object.getOwnPropertySymbols,
  v = Object.prototype.hasOwnProperty,
  $ = Object.prototype.propertyIsEnumerable,
  w = (e, o, a) => o in e ? H(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[o] = a,
  S = (e, o) => {
    for (var a in o || (o = {})) v.call(o, a) && w(e, a, o[a]);
    if (R) for (var a of R(o)) $.call(o, a) && w(e, a, o[a]);
    return e;
  },
  h = (e, o) => J(e, X(o)),
  L = (e, o) => {
    var a = {};
    for (var l in e) v.call(e, l) && o.indexOf(l) < 0 && (a[l] = e[l]);
    if (e != null && R) for (var l of R(e)) o.indexOf(l) < 0 && $.call(e, l) && (a[l] = e[l]);
    return a;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const D = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      margin: s,
      marginLeft: i,
      marginBottom: g,
      marginTop: p,
      marginRight: c
    } = a,
    d = L(a, ["tag", "color", "display", "textTransform", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, d), {
    ref: o,
    className: N("olx-text", "olx-text--display-large", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n, t("olx-m", s), t("olx-ml", i), t("olx-mb", g), t("olx-mt", p), t("olx-mr", c), u(x))
  }));
});
D.displayName = "Text.DisplayLarge";
const E = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      margin: s,
      marginLeft: i,
      marginBottom: g,
      marginTop: p,
      marginRight: c
    } = a,
    d = L(a, ["tag", "color", "display", "textTransform", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, d), {
    ref: o,
    className: N("olx-text", "olx-text--display-medium", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n, t("olx-m", s), t("olx-ml", i), t("olx-mb", g), t("olx-mt", p), t("olx-mr", c), u(x))
  }));
});
E.displayName = "Text.DisplayMedium";
const O = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      margin: s,
      marginLeft: i,
      marginBottom: g,
      marginTop: p,
      marginRight: c
    } = a,
    d = L(a, ["tag", "color", "display", "textTransform", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, d), {
    ref: o,
    className: N("olx-text", "olx-text--title-large", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n, t("olx-m", s), t("olx-ml", i), t("olx-mb", g), t("olx-mt", p), t("olx-mr", c), u(x))
  }));
});
O.displayName = "Text.TitleLarge";
const _ = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      margin: s,
      marginLeft: i,
      marginBottom: g,
      marginTop: p,
      marginRight: c
    } = a,
    d = L(a, ["tag", "color", "display", "textTransform", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, d), {
    ref: o,
    className: N("olx-text", "olx-text--title-medium", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n, t("olx-m", s), t("olx-ml", i), t("olx-mb", g), t("olx-mt", p), t("olx-mr", c), u(x))
  }));
});
_.displayName = "Text.TitleMedium";
const M = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      margin: s,
      marginLeft: i,
      marginBottom: g,
      marginTop: p,
      marginRight: c
    } = a,
    d = L(a, ["tag", "color", "display", "textTransform", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, d), {
    ref: o,
    className: N("olx-text", "olx-text--title-small", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n, t("olx-m", s), t("olx-ml", i), t("olx-mb", g), t("olx-mt", p), t("olx-mr", c), u(x))
  }));
});
M.displayName = "Text.TitleSmall";
const P = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      margin: s,
      marginLeft: i,
      marginBottom: g,
      marginTop: p,
      marginRight: c
    } = a,
    d = L(a, ["tag", "color", "display", "textTransform", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, d), {
    ref: o,
    className: N("olx-text", "olx-text--subtitle-large", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n, t("olx-m", s), t("olx-ml", i), t("olx-mb", g), t("olx-mt", p), t("olx-mr", c), u(x))
  }));
});
P.displayName = "Text.SubtitleLarge";
const j = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      margin: s,
      marginLeft: i,
      marginBottom: g,
      marginTop: p,
      marginRight: c
    } = a,
    d = L(a, ["tag", "color", "display", "textTransform", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, d), {
    ref: o,
    className: N("olx-text", "olx-text--subtitle-medium", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n, t("olx-m", s), t("olx-ml", i), t("olx-mb", g), t("olx-mt", p), t("olx-mr", c), u(x))
  }));
});
j.displayName = "Text.SubtitleMedium";
const C = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      italic: s,
      weight: i = f.weight,
      margin: g,
      marginLeft: p,
      marginBottom: c,
      marginTop: d,
      marginRight: B
    } = a,
    b = L(a, ["tag", "color", "display", "textTransform", "className", "italic", "weight", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, b), {
    ref: o,
    className: N("olx-text", "olx-text--body-large", m && "olx-text--".concat(m), r && "olx-text--".concat(r), s && "olx-text--italic", i && "olx-text--".concat(i), n, t("olx-m", g), t("olx-ml", p), t("olx-mb", c), t("olx-mt", d), t("olx-mr", B), u(x))
  }));
});
C.displayName = "Text.BodyLarge";
const I = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      italic: s,
      weight: i = f.weight,
      margin: g,
      marginLeft: p,
      marginBottom: c,
      marginTop: d,
      marginRight: B
    } = a,
    b = L(a, ["tag", "color", "display", "textTransform", "className", "italic", "weight", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, b), {
    ref: o,
    className: N("olx-text", "olx-text--body-medium", m && "olx-text--".concat(m), r && "olx-text--".concat(r), s && "olx-text--italic", i && "olx-text--".concat(i), n, t("olx-m", g), t("olx-ml", p), t("olx-mb", c), t("olx-mt", d), t("olx-mr", B), u(x))
  }));
});
I.displayName = "Text.BodyMedium";
const V = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      italic: s,
      weight: i = f.weight,
      margin: g,
      marginLeft: p,
      marginBottom: c,
      marginTop: d,
      marginRight: B
    } = a,
    b = L(a, ["tag", "color", "display", "textTransform", "className", "italic", "weight", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, b), {
    ref: o,
    className: N("olx-text", "olx-text--body-small", m && "olx-text--".concat(m), r && "olx-text--".concat(r), s && "olx-text--italic", i && "olx-text--".concat(i), n, t("olx-m", g), t("olx-ml", p), t("olx-mb", c), t("olx-mt", d), t("olx-mr", B), u(x))
  }));
});
V.displayName = "Text.BodySmall";
const W = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      weight: n = "regular",
      className: s,
      margin: i,
      marginLeft: g,
      marginBottom: p,
      marginTop: c,
      marginRight: d
    } = a,
    B = L(a, ["tag", "color", "display", "textTransform", "weight", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text"
  }, B), {
    ref: o,
    className: N("olx-text", "olx-text--caption", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n && "olx-text--".concat(n), s, t("olx-m", i), t("olx-ml", g), t("olx-mb", p), t("olx-mt", c), t("olx-mr", d), u(x))
  }));
});
W.displayName = "Text.Caption";
const A = y((e, o) => {
  var a = e,
    {
      tag: l = "span",
      color: x,
      display: m = f.display,
      textTransform: r,
      className: n,
      margin: s,
      marginLeft: i,
      marginBottom: g,
      marginTop: p,
      marginRight: c
    } = a,
    d = L(a, ["tag", "color", "display", "textTransform", "className", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]);
  return T.createElement(l, h(S({
    "data-ds-component": "DS-Text",
    "data-variant": "overline"
  }, d), {
    ref: o,
    className: N("olx-text", "olx-text--overline", m && "olx-text--".concat(m), r && "olx-text--".concat(r), n, t("olx-m", s), t("olx-ml", i), t("olx-mb", g), t("olx-mt", p), t("olx-mr", c), u(x))
  }));
});
A.displayName = "Text.Overline";
const k = {
  DisplayLarge: D,
  DisplayMedium: E,
  TitleLarge: O,
  TitleMedium: _,
  TitleSmall: M,
  SubtitleLarge: P,
  SubtitleMedium: j,
  BodyLarge: C,
  BodyMedium: I,
  BodySmall: V,
  Caption: W,
  Overline: A
};
export { k as Text };